<template>  
    <modal v-model="show"
            :max-width="modalWidth"
            :no-scroll="isHitsType"
            :title="$t('message.integrations.message.integrationTest')">         
      <slot slot="activator"></slot>
  
      <Form @submit="test" class="body" ref="form">
        <template v-if="isHitsType">
          <div class="hits-form-container">
            <app-select class="creation-body-timeout"
                        v-model="form.login"
                        :data-title="$t('message.spots.message.select')"
                        :data-search="false"
                        :data-items="hitsLoginTypes"
                        data-menu-width="fit-content"
                        />
            <text-field v-model="form.password"                        
                        :name="hitsInputName"
                        :mask="hitsMask"
                        validate="required"></text-field>
          </div>
        </template>
        <template v-else-if="isLoginAndPassword">
          <text-field v-model="form.login"
                      label="Login"
                      name="Login"
                      validate="required"></text-field>
          <text-field v-model="form.password"
                      label="Senha"
                      name="Senha"
                      validate="required"></text-field>
        </template>
        <template v-else>            
          <text-field v-model="form.login"
                      label="CPF"
                      name="CPF"
                      mask="###.###.###-##"
                      validate="required"></text-field>
        </template>            
        <div class="response" :class="{alignCenter: wasNotFoundOrCantRetriveData}" v-if="response">            
          <span class="text-not-found"  v-if="!response.found">{{$t('message.integrations.message.userNotFound')}}</span>
          <div v-else>
            <div v-if="response.allowGetClientData">
              <text-field :label="$t('message.generics.message.name')" :value="response.clientName" disabled></text-field>
              <text-field :label="$t('message.statistics.message.birthDate')" :value="response.clientBirthdate" disabled></text-field>
              <text-field :label="$t('message.statistics.message.gender')" :value="response.clientGender" disabled></text-field>
              <text-field :label="$t('message.generics.message.email')" :value="response.clientEmail" disabled></text-field>
              <text-field :label="$t('message.generics.message.phoneNumber')" :value="response.clientPhoneNumber" disabled></text-field>
            </div>
            <span class="text-not-found"  v-else-if="!response.allowGetClientData && !isLdapType">{{$t('message.integrations.message.userFoundButNoData')}}</span>
            <span class="text-not-found"  v-else-if="!response.allowGetClientData && isLdapType">{{$t('message.integrations.message.userFound')}}</span>
          </div>
        </div>
        <button v-if="!loading" type="submit"
              class="btn btn-primary btn-round">
              {{$t('message.integrations.message.send')}}
        </button>
        <div v-else class="custom-loader-wrapper">
          <div class="custom-loader">
          </div>
        </div>                
      </Form>
    </modal>
  </template>
  
  <script>
  import EventBus from "@packages/event-bus/index";
  import Modal from "@/components/generic/Modal";
  import TextField from "../../../../components/form/TextField.vue";
  import Form from "../../../../components/form/Form.vue";
  import AppSelect from "@components/Select";
  
  export default {
    components: {
      Modal,
      TextField,
      Form,
      AppSelect
    },
  
    data() {
      return {
        id: null,
        show: false,
        form: {
          accountId: undefined,
          login: undefined,
          password: ""
        },
        response: undefined,
        loading: false,
        wasNotFoundOrCantRetriveData: false
      };
    },
  
    props: {
      integration: {
        type: Object,
      }      
    },

    computed: {
      establishmentId() {
        return this.$store.state.users.user.accountId
      },
      isLoginAndPassword() {
        return this.integration.loginAndPassword
      },
      isLdapType() {
        return this.integration.appType === "LDAP"
      },
      isHitsType() {
        return this.integration.appType === "HITS"
      },
      hitsLoginTypes() {
        return [
          {id: "CPF", label: "CPF"},
          {id: "RG", label: "RG"},
          {id: "PASSPORT", label: "Passaporte"},
        ]
      },
      hitsMask() {
        return this.form.login === "CPF" ? "###.###.###-##" :
               this.form.login === "RG" ? "NNNNNNNNNNNN" :
               "NNNNNNNNNNNNNNN"
      },
      modalWidth() {
        return this.isHitsType ? "400" : "min-content"
      },
      hitsInputName() {
        return {
          ['CPF']: 'CPF',
          ['RG']: 'RG',
          ['PASSPORT']: 'Passaporte'
        }[this.form.login]
      },
      login() {
        return this.form.login
      }
    },

    watch: {
      show(val) {
        if(val) {
          this.$refs.form.reset();
          if(this.isHitsType) this.form.login = "CPF"
        } else {
          this.reset();          
        }
      },
      login(newVal, oldVal) {
        if(this.isHitsType && newVal !== oldVal) this.$refs.form.reset();
      }
    },   
  
    methods: {
      async test(){
        try {
          this.loading = true
          this.response = undefined
          this.wasNotFoundOrCantRetriveData = false
          this.form.accountId = this.establishmentId
          let loginOrCPF
          if(!this.isLoginAndPassword) {
            const cpfArray = Array.from(this.form.login)
            
            cpfArray.splice(3, 0, '.')
            cpfArray.splice(7, 0, '.')
            cpfArray.splice(11, 0, '-')
            
            const formattedCpf = cpfArray.join("")
            loginOrCPF = formattedCpf
          } else {
            loginOrCPF = this.form.login
          }
          const data = {
            accountId: this.establishmentId,
            login: loginOrCPF,
            password: this.form.password
          }
          let response = await this.$api.externalServiceIntegration.testReceive(this.integration.id, data)
          this.loading = false
          this.response = response
          if(!response.found || !response.allowGetClientData) this.wasNotFoundOrCantRetriveData = true          
          EventBus.$emit('show-message', {
              type: 'SUCCESS',
              message: "Teste realizado com sucesso",
              timeout: 3000,
          })
        } catch {
          //leave empty
         this.loading = false
         return EventBus.$emit('show-message', {
              type: 'ERROR',
              message: "Não foi possível testar a integração",
              timeout: 3000,
          })
        } finally {
          this.$emit('reload')
        }
      },
      reset() {
        this.form.login = undefined,
        this.form.password = undefined,
        this.response = undefined
      }, 
      
    },   
    
  };
  </script>
  
  <style lang="scss" scoped>
@import "~@variables";

  .v-dialog__content {
    border-radius: 5px;
  }
  .modal {
    border-radius: 5px;
  }
  
  .body {
   display: flex;
   flex-direction: column;
   gap: 20px;

   .hits-form-container {
    display: flex;
    margin-bottom: 30px;
    gap: 10px;
   }

   .alignCenter {
    margin: 0 auto;

    .text-not-found {
      font-weight: 600;
    }
   }

   .text-field {
    margin-bottom: 0;
   }

   button {
    align-self: center;
   }

   .custom-loader-wrapper {
    margin-bottom: 15px;
    display: flex;
    justify-content: center;
    .custom-loader {
      margin: 0 auto;
      width:25px;
      height:25px;
      border-radius:50%;
      background: 
        radial-gradient(farthest-side,$primary 95%,#0000) 50% 0/6px 6px no-repeat,
        radial-gradient(farthest-side,#0000 calc(100% - 2.5px),$primary calc(100% - 2px)) content-box;
      animation:s6 2s infinite ;
    }
    @keyframes s6 {to{transform: rotate(1turn)}}
  }
  }  
  </style>
  